/**
 * @generated SignedSource<<4c39a5695e0ce4ff1c938e7d0a7faf78>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteExpenseCategoryInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteExpenseCategoryMutation$variables = {
  input: DeleteExpenseCategoryInput;
};
export type deleteExpenseCategoryMutation$data = {
  readonly deleteExpenseCategory: {
    readonly deletedExpenseCategoryId: string | null;
  } | null;
};
export type deleteExpenseCategoryMutation = {
  variables: deleteExpenseCategoryMutation$variables;
  response: deleteExpenseCategoryMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteExpenseCategoryPayload",
    "kind": "LinkedField",
    "name": "deleteExpenseCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedExpenseCategoryId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteExpenseCategoryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteExpenseCategoryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2a730b37a6e75b67b917f823f2515763",
    "id": null,
    "metadata": {},
    "name": "deleteExpenseCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation deleteExpenseCategoryMutation(\n  $input: DeleteExpenseCategoryInput!\n) {\n  deleteExpenseCategory(input: $input) {\n    deletedExpenseCategoryId\n  }\n}\n"
  }
};
})();

(node as any).hash = "6712eb441bac6a1d59fb65c7a48fc4a7";

export default node;
